import * as React from "react";
import {
    Dialog,
    DialogTrigger,
    DialogSurface,
    DialogTitle,
    DialogContent,
    DialogBody,
    DialogActions,
    Button,
    Checkbox,
    CheckboxOnChangeData,
} from "@fluentui/react-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { useState } from "react";

interface AnotherComponentProps {
    Day: string;
    triggerdelete: any;
    deleteMessage1: string;
    deleteMessage2: string;
    deleteLabel: string;
    className: string;
}

export const DeleteAction: React.FC<AnotherComponentProps> = ({
    deleteMessage1,
    deleteMessage2,
    deleteLabel,
    Day,
    triggerdelete,
    className,
}) => {
    const [checked, setChecked] = React.useState(false);

    const handleChange = (
        ev: React.ChangeEvent<HTMLInputElement>,
        data: CheckboxOnChangeData
    ) => {
        setChecked(Boolean(data.checked));
    };

    const handleDeleteWorkLocation = () => {
        triggerdelete();
    };

    const openstate = (event: any, data: any) => {
        setChecked(Boolean(false));
    }

    return (
        <Dialog modalType="modal" onOpenChange={(event, data) => openstate(event, data)}>
            <DialogTrigger disableButtonEnhancement>
                <FontAwesomeIcon className={`${className}`} icon={faTrashCan} />
            </DialogTrigger>
            <DialogSurface aria-describedby={undefined}>
                <DialogBody>
                    <DialogTitle>Delete this data?</DialogTitle>
                    <DialogContent>
                        <p>
                            {deleteMessage1} {Day}. {deleteMessage2}
                        </p>
                        <Checkbox
                            checked={checked}
                            onChange={handleChange}
                            label={deleteLabel + Day}
                        />
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button disabled={!checked} appearance="primary" onClick={() => handleDeleteWorkLocation()}>
                                Delete
                            </Button>
                        </DialogTrigger>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">Cancel</Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};
